import React, { FC } from "react";
import { Box, CircularProgress, makeStyles } from "@material-ui/core";
import { Text } from "../components/Text";

interface ILoadingProps {
  text: string;
}

export const Loading: FC<ILoadingProps> = ({ text }) => {
  const classes = styles();

  return (
    <Box className={classes.loaderContainer}>
      <Text gutterBottom>{text}</Text>
      <CircularProgress className={classes.loader} color="primary" />
    </Box>
  );
};

const styles = makeStyles((theme) => ({
  loaderContainer: {
    width: "100%",
    marginTop: 80,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  loader: {
    marginTop: 20,
  },
}));
